const { getElement } = window.BAO.Utils;

class VideoToggle extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
  }

  setupListeners() {
    super.setupListeners();

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onVideoClick = this.onVideoClick.bind(this);
    this.onVideoPlay = this.onVideoPlay.bind(this);
    this.onVideoPause = this.onVideoPause.bind(this);

    this.listeners.add(this.els.trigger.element, "click", this.onTriggerClick);
    this.setupVideoListeners();
  }

  setupVideoListeners() {
    this.video = getElement(`video[data-ref="${this.dataset.videoRef}"]`);

    if (this.video) {
      if (!this.video.hasAttribute("controls")) {
        this.listeners.add(this.video, "click", this.onVideoClick);
      }

      this.listeners.add(this.video, "play", this.onVideoPlay);
      this.listeners.add(this.video, "pause", this.onVideoPause);

      if (this.video.paused) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  onTriggerClick(e) {
    e.stopPropagation();
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  onVideoClick(e) {
    if (!this.video.paused) {
      this.video.pause();
    } else {
      this.video.play();
    }
  }

  onVideoPlay() {
    this.hide();
  }

  onVideoPause() {
    this.show();
  }

  show() {
    this.style.opacity = "1";
    this.setAttribute("aria-hidden", "false");
  }

  hide() {
    this.style.opacity = "0";
    this.setAttribute("aria-hidden", "true");
  }
}

if (!customElements.get("video-toggle")) {
  customElements.define("video-toggle", VideoToggle);
}
